import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const orientationModuleAssignmentService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
};

const MODULE = {
    ORIENTATION_MODULE_ASSIGNMENT: 'orientation-module-assignments',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            usage_type: filter?.usageType,
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.ORIENTATION_MODULE_ASSIGNMENT}`, request);
}

export function store (data) {
    const request = {
        header_uuid: data.headerUuid,
        start_date: data.startDate,
        end_date: data.endDate,
        user_uuids: (data.userUuids ?? []).map(item => item),
        workgroup_uuids: (data.workgroupUuids ?? []).map(item => item),
    };

    return apiHelper(API_URL).post(`/${MODULE.ORIENTATION_MODULE_ASSIGNMENT}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.ORIENTATION_MODULE_ASSIGNMENT}/${uuid}`);
}

export function update (data) {
    const request = {
        header_uuid: data.headerUuid,
        start_date: data.startDate,
        end_date: data.endDate,
    };

    return apiHelper(API_URL).put(`/${MODULE.ORIENTATION_MODULE_ASSIGNMENT}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.ORIENTATION_MODULE_ASSIGNMENT}/${data.uuid}`, request);
}